import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
//import {Email}                    from '../interfaces/Email';

@Injectable()
export class EnviarCorreoService {
    constructor(private _http: Http,    private afs:AngularFirestore,
    ) { }

    private _contactUrl = 'app/services/enviar-correo.php';

    postEmail(newMail: any): Observable<string> {
        let body = `name=${newMail.name}&email=${newMail.email}&message=${newMail.message}`;
        let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        let options = new RequestOptions({ headers: headers });

        return this._http.post(this._contactUrl, body, options)
            .map(res => <string>res.json())
            .catch(this.handleError)
    }
    public enviarCorreoCotizacion(elemento) {
        let apiUrl ='https://envio-correos-trosten.herokuapp.com/dowork/';
		let email = elemento.email;  
		let nombre = '/'+elemento.name;
        let url = '/'+elemento.message;
		return this._http.get(apiUrl + email+ nombre + url)
        	            .map((res:Response) => res.json())
        	            .catch((error:any) => Observable.throw(error.json().error || 'success'));
    }
    public enviarCorreoCambiosCliente(elemento) {
        let apiUrl ='https://envio-correos-trosten.herokuapp.com/correoCotizacion/';
		let comentarios = elemento.comentarios;  
		let nombre = '/'+elemento.name;
        let idTrosten = '/'+elemento.idtrosten;
		return this._http.get(apiUrl + comentarios+ nombre + idTrosten)
        	            .map((res:Response) => res.json())
        	            .catch((error:any) => Observable.throw(error.json().error || 'success'));
    }

    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error('Error in retrieving news: ' + error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public notificarConfirmacionEnRojo(idConfirmacionTrosten: string, idCotizacionTrosten: string, razon: string): Promise<void> {
        const html = `
        <html>
        <head>
        <meta charset="UTF-8">
        <style>
            .header {
            width: 100%;
            height: 100px;
            background-image: url("https://www.trosten.com/media/images/M1-Catalogo-Unidades.original.jpg");
            background-size: cover;
            background-position: center;
            }
            .content {
            padding: 20px;
            font-family: Arial, sans-serif;
            }
            .footer {
            width: 100%;
            height: 10px;
            background-color: #888888;
            }
            .info-box {
            background-color: #ffecec;
            padding: 15px;
            border-left: 6px solid red;
            margin: 20px 0;
            }
        </style>
        </head>
        <body>
        <div class="header"></div>
        <div class="content">
            <h2>Alerta: Confirmación realizada con baja disponibilidad (Rojo)</h2>
            <div class="info-box">
            <p><strong>Razón:</strong> ${razon}</p>
            </div>
            <p>Se ha confirmado un servicio en la plataforma de Operaciones Trösten bajo una condición de alerta:</p>
            <ul>
            <li><strong>ID Confirmación Trösten:</strong> ${idConfirmacionTrosten}</li>
            <li><strong>ID Cotización Trösten:</strong> ${idCotizacionTrosten}</li>
            </ul>
            <p>Revisa esta confirmación lo antes posible.</p>
        </div>
        <div class="footer"></div>
        </body>
        </html>
        `;

        const mail = {
            to: 'agarcia@trosten.com',
            from: 'Trösten Transport <sales@gmail.com>',
             bcc: ['rodrigo.vq@trosten.com'],
            message: {
                subject: `[Alerta] Confirmación en Rojo - ${idConfirmacionTrosten}`,
                html: html
            }
        };

        // Assuming Firebase has already been initialized
        return this.afs.collection('mail').add(mail)
        .then(() => console.log('Correo de notificación enviado con éxito'))
        .catch(error => {
            console.error('Error al enviar el correo de notificación:', error);
            throw error;
        });
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/enviar-correo.service.ts